/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ExpiredSessionRouteImport } from './routes/expired-session'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as LoginSignupRouteImport } from './routes/_login-signup'
import { Route as ApplyRouteRouteImport } from './routes/apply/route'
import { Route as ApplicationsRouteRouteImport } from './routes/applications/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsageIndexRouteImport } from './routes/usage/index'
import { Route as BillingIndexRouteImport } from './routes/billing/index'
import { Route as ApplyIndexRouteImport } from './routes/apply/index'
import { Route as ApplicationsIndexRouteImport } from './routes/applications/index'
import { Route as UsageWaterRouteImport } from './routes/usage/water'
import { Route as UsageElectricRouteImport } from './routes/usage/electric'
import { Route as SettingsLayoutRouteImport } from './routes/settings/_layout'
import { Route as BillingStatementsRouteImport } from './routes/billing/statements'
import { Route as BillingPaymentsRouteImport } from './routes/billing/payments'
import { Route as BillingPaymentSuccessfulRouteImport } from './routes/billing/payment-successful'
import { Route as BillingMakePaymentRouteImport } from './routes/billing/make-payment'
import { Route as BillingHistoryRouteImport } from './routes/billing/history'
import { Route as ApplyVerifyEmailRouteImport } from './routes/apply/verify-email'
import { Route as ApplyResidentialRouteImport } from './routes/apply/residential'
import { Route as ApplyCommercialRouteImport } from './routes/apply/commercial'
import { Route as LoginSignupLoginRouteImport } from './routes/_login-signup/login'
import { Route as LoginSignupCreateUserRouteImport } from './routes/_login-signup/create-user'
import { Route as WizardMembershipsRouteRouteImport } from './routes/wizard/memberships/route'
import { Route as SettingsLayoutIndexRouteImport } from './routes/settings/_layout/index'
import { Route as BillingPaymentMethodsIndexRouteImport } from './routes/billing/payment-methods/index'
import { Route as BillingAutomaticPaymentsIndexRouteImport } from './routes/billing/automatic-payments/index'
import { Route as WizardMembershipsNewRouteImport } from './routes/wizard/memberships/new'
import { Route as UsersVerifyEmailTokenRouteImport } from './routes/users/verify-email/$token'
import { Route as UsersResetPasswordTokenRouteImport } from './routes/users/reset-password/$token'
import { Route as BillingPaymentMethodsNewCheckRouteImport } from './routes/billing/payment-methods/new-check'
import { Route as BillingPaymentMethodsNewCardRouteImport } from './routes/billing/payment-methods/new-card'
import { Route as BillingAutomaticPaymentsNewRouteImport } from './routes/billing/automatic-payments/new'
import { Route as ApplicationsApplicationIdSignRouteImport } from './routes/applications/$application-id/sign'
import { Route as ApplicationsApplicationIdEndRouteImport } from './routes/applications/$application-id/end'
import { Route as ApplicationsApplicationIdConsentRouteImport } from './routes/applications/$application-id/consent'
import { Route as ApplicationsApplicationIdConfirmRouteImport } from './routes/applications/$application-id/confirm'
import { Route as ApplicationsApplicationIdBillingPreferencesRouteImport } from './routes/applications/$application-id/billing-preferences'
import { Route as WizardMembershipsMemberNumberRouteRouteImport } from './routes/wizard/memberships/$member-number/route'
import { Route as WizardMembershipsMemberNumberIndexRouteImport } from './routes/wizard/memberships/$member-number/index'
import { Route as SettingsLayoutUserProfileIndexRouteImport } from './routes/settings/_layout/user-profile/index'
import { Route as SettingsLayoutMembershipsIndexRouteImport } from './routes/settings/_layout/memberships/index'
import { Route as SettingsLayoutMembershipPreferencesIndexRouteImport } from './routes/settings/_layout/membership-preferences/index'
import { Route as SettingsLayoutAuthorizedUsersIndexRouteImport } from './routes/settings/_layout/authorized-users/index'
import { Route as SettingsLayoutAccountsIndexRouteImport } from './routes/settings/_layout/accounts/index'
import { Route as ApplicationsApplicationIdServiceLocationIndexRouteImport } from './routes/applications/$application-id/service-location/index'
import { Route as ApplicationsApplicationIdIdentityCheckIndexRouteImport } from './routes/applications/$application-id/identity-check/index'
import { Route as WizardMembershipsMemberNumberTapRouteImport } from './routes/wizard/memberships/$member-number/tap'
import { Route as WizardMembershipsMemberNumberNotificationsRouteImport } from './routes/wizard/memberships/$member-number/notifications'
import { Route as WizardMembershipsMemberNumberNewsletterRouteImport } from './routes/wizard/memberships/$member-number/newsletter'
import { Route as WizardMembershipsMemberNumberGoPaperlessRouteImport } from './routes/wizard/memberships/$member-number/go-paperless'
import { Route as WizardMembershipsMemberNumberCompleteRouteImport } from './routes/wizard/memberships/$member-number/complete'
import { Route as WizardMembershipsMemberNumberAliasesRouteImport } from './routes/wizard/memberships/$member-number/aliases'
import { Route as SettingsLayoutUserProfileUpdateSmsRouteImport } from './routes/settings/_layout/user-profile/update-sms'
import { Route as SettingsLayoutUserProfileChangePasswordRouteImport } from './routes/settings/_layout/user-profile/change-password'
import { Route as SettingsLayoutUserProfileChangeNameRouteImport } from './routes/settings/_layout/user-profile/change-name'
import { Route as SettingsLayoutUserProfileChangeEmailRouteImport } from './routes/settings/_layout/user-profile/change-email'
import { Route as SettingsLayoutMembershipsMemberNumberRouteImport } from './routes/settings/_layout/memberships/$memberNumber'
import { Route as SettingsLayoutAuthorizedUsersNewRouteImport } from './routes/settings/_layout/authorized-users/new'
import { Route as SettingsLayoutAccountsAccountNumberRouteImport } from './routes/settings/_layout/accounts/$accountNumber'
import { Route as ApplicationsApplicationIdServiceLocationNewRouteImport } from './routes/applications/$application-id/service-location/new'
import { Route as ApplicationsApplicationIdServiceLocationExistingRouteImport } from './routes/applications/$application-id/service-location/existing'
import { Route as ApplicationsApplicationIdServiceLocationConfirmRouteImport } from './routes/applications/$application-id/service-location/confirm'
import { Route as ApplicationsApplicationIdIdentityCheckVerifyCodeRouteImport } from './routes/applications/$application-id/identity-check/verify-code'
import { Route as ApplicationsApplicationIdIdentityCheckSecurityQuestionsRouteImport } from './routes/applications/$application-id/identity-check/security-questions'
import { Route as WizardMembershipsMemberNumberAutomaticPaymentsIndexRouteImport } from './routes/wizard/memberships/$member-number/automatic-payments/index'
import { Route as WizardMembershipsMemberNumberAutomaticPaymentsSetupRouteImport } from './routes/wizard/memberships/$member-number/automatic-payments/setup'

const SettingsRouteImport = createFileRoute('/settings')()

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpiredSessionRoute = ExpiredSessionRouteImport.update({
  id: '/expired-session',
  path: '/expired-session',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSignupRoute = LoginSignupRouteImport.update({
  id: '/_login-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyRouteRoute = ApplyRouteRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsRouteRoute = ApplicationsRouteRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageIndexRoute = UsageIndexRouteImport.update({
  id: '/usage/',
  path: '/usage/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingIndexRoute = BillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyIndexRoute = ApplyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplyRouteRoute,
} as any)
const ApplicationsIndexRoute = ApplicationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ApplicationsRouteRoute,
} as any)
const UsageWaterRoute = UsageWaterRouteImport.update({
  id: '/usage/water',
  path: '/usage/water',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageElectricRoute = UsageElectricRouteImport.update({
  id: '/usage/electric',
  path: '/usage/electric',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLayoutRoute = SettingsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => SettingsRoute,
} as any)
const BillingStatementsRoute = BillingStatementsRouteImport.update({
  id: '/billing/statements',
  path: '/billing/statements',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPaymentsRoute = BillingPaymentsRouteImport.update({
  id: '/billing/payments',
  path: '/billing/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPaymentSuccessfulRoute =
  BillingPaymentSuccessfulRouteImport.update({
    id: '/billing/payment-successful',
    path: '/billing/payment-successful',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingMakePaymentRoute = BillingMakePaymentRouteImport.update({
  id: '/billing/make-payment',
  path: '/billing/make-payment',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingHistoryRoute = BillingHistoryRouteImport.update({
  id: '/billing/history',
  path: '/billing/history',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyVerifyEmailRoute = ApplyVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => ApplyRouteRoute,
} as any)
const ApplyResidentialRoute = ApplyResidentialRouteImport.update({
  id: '/residential',
  path: '/residential',
  getParentRoute: () => ApplyRouteRoute,
} as any)
const ApplyCommercialRoute = ApplyCommercialRouteImport.update({
  id: '/commercial',
  path: '/commercial',
  getParentRoute: () => ApplyRouteRoute,
} as any)
const LoginSignupLoginRoute = LoginSignupLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => LoginSignupRoute,
} as any)
const LoginSignupCreateUserRoute = LoginSignupCreateUserRouteImport.update({
  id: '/create-user',
  path: '/create-user',
  getParentRoute: () => LoginSignupRoute,
} as any)
const WizardMembershipsRouteRoute = WizardMembershipsRouteRouteImport.update({
  id: '/wizard/memberships',
  path: '/wizard/memberships',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLayoutIndexRoute = SettingsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsLayoutRoute,
} as any)
const BillingPaymentMethodsIndexRoute =
  BillingPaymentMethodsIndexRouteImport.update({
    id: '/billing/payment-methods/',
    path: '/billing/payment-methods/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingAutomaticPaymentsIndexRoute =
  BillingAutomaticPaymentsIndexRouteImport.update({
    id: '/billing/automatic-payments/',
    path: '/billing/automatic-payments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WizardMembershipsNewRoute = WizardMembershipsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => WizardMembershipsRouteRoute,
} as any)
const UsersVerifyEmailTokenRoute = UsersVerifyEmailTokenRouteImport.update({
  id: '/users/verify-email/$token',
  path: '/users/verify-email/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersResetPasswordTokenRoute = UsersResetPasswordTokenRouteImport.update({
  id: '/users/reset-password/$token',
  path: '/users/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPaymentMethodsNewCheckRoute =
  BillingPaymentMethodsNewCheckRouteImport.update({
    id: '/billing/payment-methods/new-check',
    path: '/billing/payment-methods/new-check',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingPaymentMethodsNewCardRoute =
  BillingPaymentMethodsNewCardRouteImport.update({
    id: '/billing/payment-methods/new-card',
    path: '/billing/payment-methods/new-card',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingAutomaticPaymentsNewRoute =
  BillingAutomaticPaymentsNewRouteImport.update({
    id: '/billing/automatic-payments/new',
    path: '/billing/automatic-payments/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const ApplicationsApplicationIdSignRoute =
  ApplicationsApplicationIdSignRouteImport.update({
    id: '/$application-id/sign',
    path: '/$application-id/sign',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdEndRoute =
  ApplicationsApplicationIdEndRouteImport.update({
    id: '/$application-id/end',
    path: '/$application-id/end',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdConsentRoute =
  ApplicationsApplicationIdConsentRouteImport.update({
    id: '/$application-id/consent',
    path: '/$application-id/consent',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdConfirmRoute =
  ApplicationsApplicationIdConfirmRouteImport.update({
    id: '/$application-id/confirm',
    path: '/$application-id/confirm',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdBillingPreferencesRoute =
  ApplicationsApplicationIdBillingPreferencesRouteImport.update({
    id: '/$application-id/billing-preferences',
    path: '/$application-id/billing-preferences',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const WizardMembershipsMemberNumberRouteRoute =
  WizardMembershipsMemberNumberRouteRouteImport.update({
    id: '/$member-number',
    path: '/$member-number',
    getParentRoute: () => WizardMembershipsRouteRoute,
  } as any)
const WizardMembershipsMemberNumberIndexRoute =
  WizardMembershipsMemberNumberIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const SettingsLayoutUserProfileIndexRoute =
  SettingsLayoutUserProfileIndexRouteImport.update({
    id: '/user-profile/',
    path: '/user-profile/',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutMembershipsIndexRoute =
  SettingsLayoutMembershipsIndexRouteImport.update({
    id: '/memberships/',
    path: '/memberships/',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutMembershipPreferencesIndexRoute =
  SettingsLayoutMembershipPreferencesIndexRouteImport.update({
    id: '/membership-preferences/',
    path: '/membership-preferences/',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutAuthorizedUsersIndexRoute =
  SettingsLayoutAuthorizedUsersIndexRouteImport.update({
    id: '/authorized-users/',
    path: '/authorized-users/',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutAccountsIndexRoute =
  SettingsLayoutAccountsIndexRouteImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const ApplicationsApplicationIdServiceLocationIndexRoute =
  ApplicationsApplicationIdServiceLocationIndexRouteImport.update({
    id: '/$application-id/service-location/',
    path: '/$application-id/service-location/',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdIdentityCheckIndexRoute =
  ApplicationsApplicationIdIdentityCheckIndexRouteImport.update({
    id: '/$application-id/identity-check/',
    path: '/$application-id/identity-check/',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const WizardMembershipsMemberNumberTapRoute =
  WizardMembershipsMemberNumberTapRouteImport.update({
    id: '/tap',
    path: '/tap',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const WizardMembershipsMemberNumberNotificationsRoute =
  WizardMembershipsMemberNumberNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const WizardMembershipsMemberNumberNewsletterRoute =
  WizardMembershipsMemberNumberNewsletterRouteImport.update({
    id: '/newsletter',
    path: '/newsletter',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const WizardMembershipsMemberNumberGoPaperlessRoute =
  WizardMembershipsMemberNumberGoPaperlessRouteImport.update({
    id: '/go-paperless',
    path: '/go-paperless',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const WizardMembershipsMemberNumberCompleteRoute =
  WizardMembershipsMemberNumberCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const WizardMembershipsMemberNumberAliasesRoute =
  WizardMembershipsMemberNumberAliasesRouteImport.update({
    id: '/aliases',
    path: '/aliases',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const SettingsLayoutUserProfileUpdateSmsRoute =
  SettingsLayoutUserProfileUpdateSmsRouteImport.update({
    id: '/user-profile/update-sms',
    path: '/user-profile/update-sms',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutUserProfileChangePasswordRoute =
  SettingsLayoutUserProfileChangePasswordRouteImport.update({
    id: '/user-profile/change-password',
    path: '/user-profile/change-password',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutUserProfileChangeNameRoute =
  SettingsLayoutUserProfileChangeNameRouteImport.update({
    id: '/user-profile/change-name',
    path: '/user-profile/change-name',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutUserProfileChangeEmailRoute =
  SettingsLayoutUserProfileChangeEmailRouteImport.update({
    id: '/user-profile/change-email',
    path: '/user-profile/change-email',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutMembershipsMemberNumberRoute =
  SettingsLayoutMembershipsMemberNumberRouteImport.update({
    id: '/memberships/$memberNumber',
    path: '/memberships/$memberNumber',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutAuthorizedUsersNewRoute =
  SettingsLayoutAuthorizedUsersNewRouteImport.update({
    id: '/authorized-users/new',
    path: '/authorized-users/new',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const SettingsLayoutAccountsAccountNumberRoute =
  SettingsLayoutAccountsAccountNumberRouteImport.update({
    id: '/accounts/$accountNumber',
    path: '/accounts/$accountNumber',
    getParentRoute: () => SettingsLayoutRoute,
  } as any)
const ApplicationsApplicationIdServiceLocationNewRoute =
  ApplicationsApplicationIdServiceLocationNewRouteImport.update({
    id: '/$application-id/service-location/new',
    path: '/$application-id/service-location/new',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdServiceLocationExistingRoute =
  ApplicationsApplicationIdServiceLocationExistingRouteImport.update({
    id: '/$application-id/service-location/existing',
    path: '/$application-id/service-location/existing',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdServiceLocationConfirmRoute =
  ApplicationsApplicationIdServiceLocationConfirmRouteImport.update({
    id: '/$application-id/service-location/confirm',
    path: '/$application-id/service-location/confirm',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdIdentityCheckVerifyCodeRoute =
  ApplicationsApplicationIdIdentityCheckVerifyCodeRouteImport.update({
    id: '/$application-id/identity-check/verify-code',
    path: '/$application-id/identity-check/verify-code',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute =
  ApplicationsApplicationIdIdentityCheckSecurityQuestionsRouteImport.update({
    id: '/$application-id/identity-check/security-questions',
    path: '/$application-id/identity-check/security-questions',
    getParentRoute: () => ApplicationsRouteRoute,
  } as any)
const WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute =
  WizardMembershipsMemberNumberAutomaticPaymentsIndexRouteImport.update({
    id: '/automatic-payments/',
    path: '/automatic-payments/',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)
const WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute =
  WizardMembershipsMemberNumberAutomaticPaymentsSetupRouteImport.update({
    id: '/automatic-payments/setup',
    path: '/automatic-payments/setup',
    getParentRoute: () => WizardMembershipsMemberNumberRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/applications': typeof ApplicationsRouteRouteWithChildren
  '/apply': typeof ApplyRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/expired-session': typeof ExpiredSessionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/notifications': typeof NotificationsRoute
  '/wizard/memberships': typeof WizardMembershipsRouteRouteWithChildren
  '/create-user': typeof LoginSignupCreateUserRoute
  '/login': typeof LoginSignupLoginRoute
  '/apply/commercial': typeof ApplyCommercialRoute
  '/apply/residential': typeof ApplyResidentialRoute
  '/apply/verify-email': typeof ApplyVerifyEmailRoute
  '/billing/history': typeof BillingHistoryRoute
  '/billing/make-payment': typeof BillingMakePaymentRoute
  '/billing/payment-successful': typeof BillingPaymentSuccessfulRoute
  '/billing/payments': typeof BillingPaymentsRoute
  '/billing/statements': typeof BillingStatementsRoute
  '/settings': typeof SettingsLayoutRouteWithChildren
  '/usage/electric': typeof UsageElectricRoute
  '/usage/water': typeof UsageWaterRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/apply/': typeof ApplyIndexRoute
  '/billing': typeof BillingIndexRoute
  '/usage': typeof UsageIndexRoute
  '/wizard/memberships/$member-number': typeof WizardMembershipsMemberNumberRouteRouteWithChildren
  '/applications/$application-id/billing-preferences': typeof ApplicationsApplicationIdBillingPreferencesRoute
  '/applications/$application-id/confirm': typeof ApplicationsApplicationIdConfirmRoute
  '/applications/$application-id/consent': typeof ApplicationsApplicationIdConsentRoute
  '/applications/$application-id/end': typeof ApplicationsApplicationIdEndRoute
  '/applications/$application-id/sign': typeof ApplicationsApplicationIdSignRoute
  '/billing/automatic-payments/new': typeof BillingAutomaticPaymentsNewRoute
  '/billing/payment-methods/new-card': typeof BillingPaymentMethodsNewCardRoute
  '/billing/payment-methods/new-check': typeof BillingPaymentMethodsNewCheckRoute
  '/users/reset-password/$token': typeof UsersResetPasswordTokenRoute
  '/users/verify-email/$token': typeof UsersVerifyEmailTokenRoute
  '/wizard/memberships/new': typeof WizardMembershipsNewRoute
  '/billing/automatic-payments': typeof BillingAutomaticPaymentsIndexRoute
  '/billing/payment-methods': typeof BillingPaymentMethodsIndexRoute
  '/settings/': typeof SettingsLayoutIndexRoute
  '/applications/$application-id/identity-check/security-questions': typeof ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute
  '/applications/$application-id/identity-check/verify-code': typeof ApplicationsApplicationIdIdentityCheckVerifyCodeRoute
  '/applications/$application-id/service-location/confirm': typeof ApplicationsApplicationIdServiceLocationConfirmRoute
  '/applications/$application-id/service-location/existing': typeof ApplicationsApplicationIdServiceLocationExistingRoute
  '/applications/$application-id/service-location/new': typeof ApplicationsApplicationIdServiceLocationNewRoute
  '/settings/accounts/$accountNumber': typeof SettingsLayoutAccountsAccountNumberRoute
  '/settings/authorized-users/new': typeof SettingsLayoutAuthorizedUsersNewRoute
  '/settings/memberships/$memberNumber': typeof SettingsLayoutMembershipsMemberNumberRoute
  '/settings/user-profile/change-email': typeof SettingsLayoutUserProfileChangeEmailRoute
  '/settings/user-profile/change-name': typeof SettingsLayoutUserProfileChangeNameRoute
  '/settings/user-profile/change-password': typeof SettingsLayoutUserProfileChangePasswordRoute
  '/settings/user-profile/update-sms': typeof SettingsLayoutUserProfileUpdateSmsRoute
  '/wizard/memberships/$member-number/aliases': typeof WizardMembershipsMemberNumberAliasesRoute
  '/wizard/memberships/$member-number/complete': typeof WizardMembershipsMemberNumberCompleteRoute
  '/wizard/memberships/$member-number/go-paperless': typeof WizardMembershipsMemberNumberGoPaperlessRoute
  '/wizard/memberships/$member-number/newsletter': typeof WizardMembershipsMemberNumberNewsletterRoute
  '/wizard/memberships/$member-number/notifications': typeof WizardMembershipsMemberNumberNotificationsRoute
  '/wizard/memberships/$member-number/tap': typeof WizardMembershipsMemberNumberTapRoute
  '/applications/$application-id/identity-check': typeof ApplicationsApplicationIdIdentityCheckIndexRoute
  '/applications/$application-id/service-location': typeof ApplicationsApplicationIdServiceLocationIndexRoute
  '/settings/accounts': typeof SettingsLayoutAccountsIndexRoute
  '/settings/authorized-users': typeof SettingsLayoutAuthorizedUsersIndexRoute
  '/settings/membership-preferences': typeof SettingsLayoutMembershipPreferencesIndexRoute
  '/settings/memberships': typeof SettingsLayoutMembershipsIndexRoute
  '/settings/user-profile': typeof SettingsLayoutUserProfileIndexRoute
  '/wizard/memberships/$member-number/': typeof WizardMembershipsMemberNumberIndexRoute
  '/wizard/memberships/$member-number/automatic-payments/setup': typeof WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute
  '/wizard/memberships/$member-number/automatic-payments': typeof WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/expired-session': typeof ExpiredSessionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/notifications': typeof NotificationsRoute
  '/wizard/memberships': typeof WizardMembershipsRouteRouteWithChildren
  '/create-user': typeof LoginSignupCreateUserRoute
  '/login': typeof LoginSignupLoginRoute
  '/apply/commercial': typeof ApplyCommercialRoute
  '/apply/residential': typeof ApplyResidentialRoute
  '/apply/verify-email': typeof ApplyVerifyEmailRoute
  '/billing/history': typeof BillingHistoryRoute
  '/billing/make-payment': typeof BillingMakePaymentRoute
  '/billing/payment-successful': typeof BillingPaymentSuccessfulRoute
  '/billing/payments': typeof BillingPaymentsRoute
  '/billing/statements': typeof BillingStatementsRoute
  '/settings': typeof SettingsLayoutIndexRoute
  '/usage/electric': typeof UsageElectricRoute
  '/usage/water': typeof UsageWaterRoute
  '/applications': typeof ApplicationsIndexRoute
  '/apply': typeof ApplyIndexRoute
  '/billing': typeof BillingIndexRoute
  '/usage': typeof UsageIndexRoute
  '/applications/$application-id/billing-preferences': typeof ApplicationsApplicationIdBillingPreferencesRoute
  '/applications/$application-id/confirm': typeof ApplicationsApplicationIdConfirmRoute
  '/applications/$application-id/consent': typeof ApplicationsApplicationIdConsentRoute
  '/applications/$application-id/end': typeof ApplicationsApplicationIdEndRoute
  '/applications/$application-id/sign': typeof ApplicationsApplicationIdSignRoute
  '/billing/automatic-payments/new': typeof BillingAutomaticPaymentsNewRoute
  '/billing/payment-methods/new-card': typeof BillingPaymentMethodsNewCardRoute
  '/billing/payment-methods/new-check': typeof BillingPaymentMethodsNewCheckRoute
  '/users/reset-password/$token': typeof UsersResetPasswordTokenRoute
  '/users/verify-email/$token': typeof UsersVerifyEmailTokenRoute
  '/wizard/memberships/new': typeof WizardMembershipsNewRoute
  '/billing/automatic-payments': typeof BillingAutomaticPaymentsIndexRoute
  '/billing/payment-methods': typeof BillingPaymentMethodsIndexRoute
  '/applications/$application-id/identity-check/security-questions': typeof ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute
  '/applications/$application-id/identity-check/verify-code': typeof ApplicationsApplicationIdIdentityCheckVerifyCodeRoute
  '/applications/$application-id/service-location/confirm': typeof ApplicationsApplicationIdServiceLocationConfirmRoute
  '/applications/$application-id/service-location/existing': typeof ApplicationsApplicationIdServiceLocationExistingRoute
  '/applications/$application-id/service-location/new': typeof ApplicationsApplicationIdServiceLocationNewRoute
  '/settings/accounts/$accountNumber': typeof SettingsLayoutAccountsAccountNumberRoute
  '/settings/authorized-users/new': typeof SettingsLayoutAuthorizedUsersNewRoute
  '/settings/memberships/$memberNumber': typeof SettingsLayoutMembershipsMemberNumberRoute
  '/settings/user-profile/change-email': typeof SettingsLayoutUserProfileChangeEmailRoute
  '/settings/user-profile/change-name': typeof SettingsLayoutUserProfileChangeNameRoute
  '/settings/user-profile/change-password': typeof SettingsLayoutUserProfileChangePasswordRoute
  '/settings/user-profile/update-sms': typeof SettingsLayoutUserProfileUpdateSmsRoute
  '/wizard/memberships/$member-number/aliases': typeof WizardMembershipsMemberNumberAliasesRoute
  '/wizard/memberships/$member-number/complete': typeof WizardMembershipsMemberNumberCompleteRoute
  '/wizard/memberships/$member-number/go-paperless': typeof WizardMembershipsMemberNumberGoPaperlessRoute
  '/wizard/memberships/$member-number/newsletter': typeof WizardMembershipsMemberNumberNewsletterRoute
  '/wizard/memberships/$member-number/notifications': typeof WizardMembershipsMemberNumberNotificationsRoute
  '/wizard/memberships/$member-number/tap': typeof WizardMembershipsMemberNumberTapRoute
  '/applications/$application-id/identity-check': typeof ApplicationsApplicationIdIdentityCheckIndexRoute
  '/applications/$application-id/service-location': typeof ApplicationsApplicationIdServiceLocationIndexRoute
  '/settings/accounts': typeof SettingsLayoutAccountsIndexRoute
  '/settings/authorized-users': typeof SettingsLayoutAuthorizedUsersIndexRoute
  '/settings/membership-preferences': typeof SettingsLayoutMembershipPreferencesIndexRoute
  '/settings/memberships': typeof SettingsLayoutMembershipsIndexRoute
  '/settings/user-profile': typeof SettingsLayoutUserProfileIndexRoute
  '/wizard/memberships/$member-number': typeof WizardMembershipsMemberNumberIndexRoute
  '/wizard/memberships/$member-number/automatic-payments/setup': typeof WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute
  '/wizard/memberships/$member-number/automatic-payments': typeof WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/applications': typeof ApplicationsRouteRouteWithChildren
  '/apply': typeof ApplyRouteRouteWithChildren
  '/_login-signup': typeof LoginSignupRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/expired-session': typeof ExpiredSessionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/notifications': typeof NotificationsRoute
  '/wizard/memberships': typeof WizardMembershipsRouteRouteWithChildren
  '/_login-signup/create-user': typeof LoginSignupCreateUserRoute
  '/_login-signup/login': typeof LoginSignupLoginRoute
  '/apply/commercial': typeof ApplyCommercialRoute
  '/apply/residential': typeof ApplyResidentialRoute
  '/apply/verify-email': typeof ApplyVerifyEmailRoute
  '/billing/history': typeof BillingHistoryRoute
  '/billing/make-payment': typeof BillingMakePaymentRoute
  '/billing/payment-successful': typeof BillingPaymentSuccessfulRoute
  '/billing/payments': typeof BillingPaymentsRoute
  '/billing/statements': typeof BillingStatementsRoute
  '/settings': typeof SettingsRouteWithChildren
  '/settings/_layout': typeof SettingsLayoutRouteWithChildren
  '/usage/electric': typeof UsageElectricRoute
  '/usage/water': typeof UsageWaterRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/apply/': typeof ApplyIndexRoute
  '/billing/': typeof BillingIndexRoute
  '/usage/': typeof UsageIndexRoute
  '/wizard/memberships/$member-number': typeof WizardMembershipsMemberNumberRouteRouteWithChildren
  '/applications/$application-id/billing-preferences': typeof ApplicationsApplicationIdBillingPreferencesRoute
  '/applications/$application-id/confirm': typeof ApplicationsApplicationIdConfirmRoute
  '/applications/$application-id/consent': typeof ApplicationsApplicationIdConsentRoute
  '/applications/$application-id/end': typeof ApplicationsApplicationIdEndRoute
  '/applications/$application-id/sign': typeof ApplicationsApplicationIdSignRoute
  '/billing/automatic-payments/new': typeof BillingAutomaticPaymentsNewRoute
  '/billing/payment-methods/new-card': typeof BillingPaymentMethodsNewCardRoute
  '/billing/payment-methods/new-check': typeof BillingPaymentMethodsNewCheckRoute
  '/users/reset-password/$token': typeof UsersResetPasswordTokenRoute
  '/users/verify-email/$token': typeof UsersVerifyEmailTokenRoute
  '/wizard/memberships/new': typeof WizardMembershipsNewRoute
  '/billing/automatic-payments/': typeof BillingAutomaticPaymentsIndexRoute
  '/billing/payment-methods/': typeof BillingPaymentMethodsIndexRoute
  '/settings/_layout/': typeof SettingsLayoutIndexRoute
  '/applications/$application-id/identity-check/security-questions': typeof ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute
  '/applications/$application-id/identity-check/verify-code': typeof ApplicationsApplicationIdIdentityCheckVerifyCodeRoute
  '/applications/$application-id/service-location/confirm': typeof ApplicationsApplicationIdServiceLocationConfirmRoute
  '/applications/$application-id/service-location/existing': typeof ApplicationsApplicationIdServiceLocationExistingRoute
  '/applications/$application-id/service-location/new': typeof ApplicationsApplicationIdServiceLocationNewRoute
  '/settings/_layout/accounts/$accountNumber': typeof SettingsLayoutAccountsAccountNumberRoute
  '/settings/_layout/authorized-users/new': typeof SettingsLayoutAuthorizedUsersNewRoute
  '/settings/_layout/memberships/$memberNumber': typeof SettingsLayoutMembershipsMemberNumberRoute
  '/settings/_layout/user-profile/change-email': typeof SettingsLayoutUserProfileChangeEmailRoute
  '/settings/_layout/user-profile/change-name': typeof SettingsLayoutUserProfileChangeNameRoute
  '/settings/_layout/user-profile/change-password': typeof SettingsLayoutUserProfileChangePasswordRoute
  '/settings/_layout/user-profile/update-sms': typeof SettingsLayoutUserProfileUpdateSmsRoute
  '/wizard/memberships/$member-number/aliases': typeof WizardMembershipsMemberNumberAliasesRoute
  '/wizard/memberships/$member-number/complete': typeof WizardMembershipsMemberNumberCompleteRoute
  '/wizard/memberships/$member-number/go-paperless': typeof WizardMembershipsMemberNumberGoPaperlessRoute
  '/wizard/memberships/$member-number/newsletter': typeof WizardMembershipsMemberNumberNewsletterRoute
  '/wizard/memberships/$member-number/notifications': typeof WizardMembershipsMemberNumberNotificationsRoute
  '/wizard/memberships/$member-number/tap': typeof WizardMembershipsMemberNumberTapRoute
  '/applications/$application-id/identity-check/': typeof ApplicationsApplicationIdIdentityCheckIndexRoute
  '/applications/$application-id/service-location/': typeof ApplicationsApplicationIdServiceLocationIndexRoute
  '/settings/_layout/accounts/': typeof SettingsLayoutAccountsIndexRoute
  '/settings/_layout/authorized-users/': typeof SettingsLayoutAuthorizedUsersIndexRoute
  '/settings/_layout/membership-preferences/': typeof SettingsLayoutMembershipPreferencesIndexRoute
  '/settings/_layout/memberships/': typeof SettingsLayoutMembershipsIndexRoute
  '/settings/_layout/user-profile/': typeof SettingsLayoutUserProfileIndexRoute
  '/wizard/memberships/$member-number/': typeof WizardMembershipsMemberNumberIndexRoute
  '/wizard/memberships/$member-number/automatic-payments/setup': typeof WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute
  '/wizard/memberships/$member-number/automatic-payments/': typeof WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/applications'
    | '/apply'
    | '/accept-invite'
    | '/expired-session'
    | '/forgot-password'
    | '/impersonate'
    | '/notifications'
    | '/wizard/memberships'
    | '/create-user'
    | '/login'
    | '/apply/commercial'
    | '/apply/residential'
    | '/apply/verify-email'
    | '/billing/history'
    | '/billing/make-payment'
    | '/billing/payment-successful'
    | '/billing/payments'
    | '/billing/statements'
    | '/settings'
    | '/usage/electric'
    | '/usage/water'
    | '/applications/'
    | '/apply/'
    | '/billing'
    | '/usage'
    | '/wizard/memberships/$member-number'
    | '/applications/$application-id/billing-preferences'
    | '/applications/$application-id/confirm'
    | '/applications/$application-id/consent'
    | '/applications/$application-id/end'
    | '/applications/$application-id/sign'
    | '/billing/automatic-payments/new'
    | '/billing/payment-methods/new-card'
    | '/billing/payment-methods/new-check'
    | '/users/reset-password/$token'
    | '/users/verify-email/$token'
    | '/wizard/memberships/new'
    | '/billing/automatic-payments'
    | '/billing/payment-methods'
    | '/settings/'
    | '/applications/$application-id/identity-check/security-questions'
    | '/applications/$application-id/identity-check/verify-code'
    | '/applications/$application-id/service-location/confirm'
    | '/applications/$application-id/service-location/existing'
    | '/applications/$application-id/service-location/new'
    | '/settings/accounts/$accountNumber'
    | '/settings/authorized-users/new'
    | '/settings/memberships/$memberNumber'
    | '/settings/user-profile/change-email'
    | '/settings/user-profile/change-name'
    | '/settings/user-profile/change-password'
    | '/settings/user-profile/update-sms'
    | '/wizard/memberships/$member-number/aliases'
    | '/wizard/memberships/$member-number/complete'
    | '/wizard/memberships/$member-number/go-paperless'
    | '/wizard/memberships/$member-number/newsletter'
    | '/wizard/memberships/$member-number/notifications'
    | '/wizard/memberships/$member-number/tap'
    | '/applications/$application-id/identity-check'
    | '/applications/$application-id/service-location'
    | '/settings/accounts'
    | '/settings/authorized-users'
    | '/settings/membership-preferences'
    | '/settings/memberships'
    | '/settings/user-profile'
    | '/wizard/memberships/$member-number/'
    | '/wizard/memberships/$member-number/automatic-payments/setup'
    | '/wizard/memberships/$member-number/automatic-payments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/expired-session'
    | '/forgot-password'
    | '/impersonate'
    | '/notifications'
    | '/wizard/memberships'
    | '/create-user'
    | '/login'
    | '/apply/commercial'
    | '/apply/residential'
    | '/apply/verify-email'
    | '/billing/history'
    | '/billing/make-payment'
    | '/billing/payment-successful'
    | '/billing/payments'
    | '/billing/statements'
    | '/settings'
    | '/usage/electric'
    | '/usage/water'
    | '/applications'
    | '/apply'
    | '/billing'
    | '/usage'
    | '/applications/$application-id/billing-preferences'
    | '/applications/$application-id/confirm'
    | '/applications/$application-id/consent'
    | '/applications/$application-id/end'
    | '/applications/$application-id/sign'
    | '/billing/automatic-payments/new'
    | '/billing/payment-methods/new-card'
    | '/billing/payment-methods/new-check'
    | '/users/reset-password/$token'
    | '/users/verify-email/$token'
    | '/wizard/memberships/new'
    | '/billing/automatic-payments'
    | '/billing/payment-methods'
    | '/applications/$application-id/identity-check/security-questions'
    | '/applications/$application-id/identity-check/verify-code'
    | '/applications/$application-id/service-location/confirm'
    | '/applications/$application-id/service-location/existing'
    | '/applications/$application-id/service-location/new'
    | '/settings/accounts/$accountNumber'
    | '/settings/authorized-users/new'
    | '/settings/memberships/$memberNumber'
    | '/settings/user-profile/change-email'
    | '/settings/user-profile/change-name'
    | '/settings/user-profile/change-password'
    | '/settings/user-profile/update-sms'
    | '/wizard/memberships/$member-number/aliases'
    | '/wizard/memberships/$member-number/complete'
    | '/wizard/memberships/$member-number/go-paperless'
    | '/wizard/memberships/$member-number/newsletter'
    | '/wizard/memberships/$member-number/notifications'
    | '/wizard/memberships/$member-number/tap'
    | '/applications/$application-id/identity-check'
    | '/applications/$application-id/service-location'
    | '/settings/accounts'
    | '/settings/authorized-users'
    | '/settings/membership-preferences'
    | '/settings/memberships'
    | '/settings/user-profile'
    | '/wizard/memberships/$member-number'
    | '/wizard/memberships/$member-number/automatic-payments/setup'
    | '/wizard/memberships/$member-number/automatic-payments'
  id:
    | '__root__'
    | '/'
    | '/applications'
    | '/apply'
    | '/_login-signup'
    | '/accept-invite'
    | '/expired-session'
    | '/forgot-password'
    | '/impersonate'
    | '/notifications'
    | '/wizard/memberships'
    | '/_login-signup/create-user'
    | '/_login-signup/login'
    | '/apply/commercial'
    | '/apply/residential'
    | '/apply/verify-email'
    | '/billing/history'
    | '/billing/make-payment'
    | '/billing/payment-successful'
    | '/billing/payments'
    | '/billing/statements'
    | '/settings'
    | '/settings/_layout'
    | '/usage/electric'
    | '/usage/water'
    | '/applications/'
    | '/apply/'
    | '/billing/'
    | '/usage/'
    | '/wizard/memberships/$member-number'
    | '/applications/$application-id/billing-preferences'
    | '/applications/$application-id/confirm'
    | '/applications/$application-id/consent'
    | '/applications/$application-id/end'
    | '/applications/$application-id/sign'
    | '/billing/automatic-payments/new'
    | '/billing/payment-methods/new-card'
    | '/billing/payment-methods/new-check'
    | '/users/reset-password/$token'
    | '/users/verify-email/$token'
    | '/wizard/memberships/new'
    | '/billing/automatic-payments/'
    | '/billing/payment-methods/'
    | '/settings/_layout/'
    | '/applications/$application-id/identity-check/security-questions'
    | '/applications/$application-id/identity-check/verify-code'
    | '/applications/$application-id/service-location/confirm'
    | '/applications/$application-id/service-location/existing'
    | '/applications/$application-id/service-location/new'
    | '/settings/_layout/accounts/$accountNumber'
    | '/settings/_layout/authorized-users/new'
    | '/settings/_layout/memberships/$memberNumber'
    | '/settings/_layout/user-profile/change-email'
    | '/settings/_layout/user-profile/change-name'
    | '/settings/_layout/user-profile/change-password'
    | '/settings/_layout/user-profile/update-sms'
    | '/wizard/memberships/$member-number/aliases'
    | '/wizard/memberships/$member-number/complete'
    | '/wizard/memberships/$member-number/go-paperless'
    | '/wizard/memberships/$member-number/newsletter'
    | '/wizard/memberships/$member-number/notifications'
    | '/wizard/memberships/$member-number/tap'
    | '/applications/$application-id/identity-check/'
    | '/applications/$application-id/service-location/'
    | '/settings/_layout/accounts/'
    | '/settings/_layout/authorized-users/'
    | '/settings/_layout/membership-preferences/'
    | '/settings/_layout/memberships/'
    | '/settings/_layout/user-profile/'
    | '/wizard/memberships/$member-number/'
    | '/wizard/memberships/$member-number/automatic-payments/setup'
    | '/wizard/memberships/$member-number/automatic-payments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ApplicationsRouteRoute: typeof ApplicationsRouteRouteWithChildren
  ApplyRouteRoute: typeof ApplyRouteRouteWithChildren
  LoginSignupRoute: typeof LoginSignupRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ExpiredSessionRoute: typeof ExpiredSessionRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ImpersonateRoute: typeof ImpersonateRoute
  NotificationsRoute: typeof NotificationsRoute
  WizardMembershipsRouteRoute: typeof WizardMembershipsRouteRouteWithChildren
  BillingHistoryRoute: typeof BillingHistoryRoute
  BillingMakePaymentRoute: typeof BillingMakePaymentRoute
  BillingPaymentSuccessfulRoute: typeof BillingPaymentSuccessfulRoute
  BillingPaymentsRoute: typeof BillingPaymentsRoute
  BillingStatementsRoute: typeof BillingStatementsRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  UsageElectricRoute: typeof UsageElectricRoute
  UsageWaterRoute: typeof UsageWaterRoute
  BillingIndexRoute: typeof BillingIndexRoute
  UsageIndexRoute: typeof UsageIndexRoute
  BillingAutomaticPaymentsNewRoute: typeof BillingAutomaticPaymentsNewRoute
  BillingPaymentMethodsNewCardRoute: typeof BillingPaymentMethodsNewCardRoute
  BillingPaymentMethodsNewCheckRoute: typeof BillingPaymentMethodsNewCheckRoute
  UsersResetPasswordTokenRoute: typeof UsersResetPasswordTokenRoute
  UsersVerifyEmailTokenRoute: typeof UsersVerifyEmailTokenRoute
  BillingAutomaticPaymentsIndexRoute: typeof BillingAutomaticPaymentsIndexRoute
  BillingPaymentMethodsIndexRoute: typeof BillingPaymentMethodsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expired-session': {
      id: '/expired-session'
      path: '/expired-session'
      fullPath: '/expired-session'
      preLoaderRoute: typeof ExpiredSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login-signup': {
      id: '/_login-signup'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LoginSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply': {
      id: '/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof ApplyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications': {
      id: '/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof ApplicationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage/': {
      id: '/usage/'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/': {
      id: '/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/': {
      id: '/apply/'
      path: '/'
      fullPath: '/apply/'
      preLoaderRoute: typeof ApplyIndexRouteImport
      parentRoute: typeof ApplyRouteRoute
    }
    '/applications/': {
      id: '/applications/'
      path: '/'
      fullPath: '/applications/'
      preLoaderRoute: typeof ApplicationsIndexRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/usage/water': {
      id: '/usage/water'
      path: '/usage/water'
      fullPath: '/usage/water'
      preLoaderRoute: typeof UsageWaterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage/electric': {
      id: '/usage/electric'
      path: '/usage/electric'
      fullPath: '/usage/electric'
      preLoaderRoute: typeof UsageElectricRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/_layout': {
      id: '/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLayoutRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/billing/statements': {
      id: '/billing/statements'
      path: '/billing/statements'
      fullPath: '/billing/statements'
      preLoaderRoute: typeof BillingStatementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payments': {
      id: '/billing/payments'
      path: '/billing/payments'
      fullPath: '/billing/payments'
      preLoaderRoute: typeof BillingPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payment-successful': {
      id: '/billing/payment-successful'
      path: '/billing/payment-successful'
      fullPath: '/billing/payment-successful'
      preLoaderRoute: typeof BillingPaymentSuccessfulRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/make-payment': {
      id: '/billing/make-payment'
      path: '/billing/make-payment'
      fullPath: '/billing/make-payment'
      preLoaderRoute: typeof BillingMakePaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/history': {
      id: '/billing/history'
      path: '/billing/history'
      fullPath: '/billing/history'
      preLoaderRoute: typeof BillingHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/verify-email': {
      id: '/apply/verify-email'
      path: '/verify-email'
      fullPath: '/apply/verify-email'
      preLoaderRoute: typeof ApplyVerifyEmailRouteImport
      parentRoute: typeof ApplyRouteRoute
    }
    '/apply/residential': {
      id: '/apply/residential'
      path: '/residential'
      fullPath: '/apply/residential'
      preLoaderRoute: typeof ApplyResidentialRouteImport
      parentRoute: typeof ApplyRouteRoute
    }
    '/apply/commercial': {
      id: '/apply/commercial'
      path: '/commercial'
      fullPath: '/apply/commercial'
      preLoaderRoute: typeof ApplyCommercialRouteImport
      parentRoute: typeof ApplyRouteRoute
    }
    '/_login-signup/login': {
      id: '/_login-signup/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginSignupLoginRouteImport
      parentRoute: typeof LoginSignupRoute
    }
    '/_login-signup/create-user': {
      id: '/_login-signup/create-user'
      path: '/create-user'
      fullPath: '/create-user'
      preLoaderRoute: typeof LoginSignupCreateUserRouteImport
      parentRoute: typeof LoginSignupRoute
    }
    '/wizard/memberships': {
      id: '/wizard/memberships'
      path: '/wizard/memberships'
      fullPath: '/wizard/memberships'
      preLoaderRoute: typeof WizardMembershipsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/_layout/': {
      id: '/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsLayoutIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/billing/payment-methods/': {
      id: '/billing/payment-methods/'
      path: '/billing/payment-methods'
      fullPath: '/billing/payment-methods'
      preLoaderRoute: typeof BillingPaymentMethodsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/automatic-payments/': {
      id: '/billing/automatic-payments/'
      path: '/billing/automatic-payments'
      fullPath: '/billing/automatic-payments'
      preLoaderRoute: typeof BillingAutomaticPaymentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wizard/memberships/new': {
      id: '/wizard/memberships/new'
      path: '/new'
      fullPath: '/wizard/memberships/new'
      preLoaderRoute: typeof WizardMembershipsNewRouteImport
      parentRoute: typeof WizardMembershipsRouteRoute
    }
    '/users/verify-email/$token': {
      id: '/users/verify-email/$token'
      path: '/users/verify-email/$token'
      fullPath: '/users/verify-email/$token'
      preLoaderRoute: typeof UsersVerifyEmailTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/reset-password/$token': {
      id: '/users/reset-password/$token'
      path: '/users/reset-password/$token'
      fullPath: '/users/reset-password/$token'
      preLoaderRoute: typeof UsersResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payment-methods/new-check': {
      id: '/billing/payment-methods/new-check'
      path: '/billing/payment-methods/new-check'
      fullPath: '/billing/payment-methods/new-check'
      preLoaderRoute: typeof BillingPaymentMethodsNewCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payment-methods/new-card': {
      id: '/billing/payment-methods/new-card'
      path: '/billing/payment-methods/new-card'
      fullPath: '/billing/payment-methods/new-card'
      preLoaderRoute: typeof BillingPaymentMethodsNewCardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/automatic-payments/new': {
      id: '/billing/automatic-payments/new'
      path: '/billing/automatic-payments/new'
      fullPath: '/billing/automatic-payments/new'
      preLoaderRoute: typeof BillingAutomaticPaymentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/$application-id/sign': {
      id: '/applications/$application-id/sign'
      path: '/$application-id/sign'
      fullPath: '/applications/$application-id/sign'
      preLoaderRoute: typeof ApplicationsApplicationIdSignRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/end': {
      id: '/applications/$application-id/end'
      path: '/$application-id/end'
      fullPath: '/applications/$application-id/end'
      preLoaderRoute: typeof ApplicationsApplicationIdEndRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/consent': {
      id: '/applications/$application-id/consent'
      path: '/$application-id/consent'
      fullPath: '/applications/$application-id/consent'
      preLoaderRoute: typeof ApplicationsApplicationIdConsentRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/confirm': {
      id: '/applications/$application-id/confirm'
      path: '/$application-id/confirm'
      fullPath: '/applications/$application-id/confirm'
      preLoaderRoute: typeof ApplicationsApplicationIdConfirmRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/billing-preferences': {
      id: '/applications/$application-id/billing-preferences'
      path: '/$application-id/billing-preferences'
      fullPath: '/applications/$application-id/billing-preferences'
      preLoaderRoute: typeof ApplicationsApplicationIdBillingPreferencesRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/wizard/memberships/$member-number': {
      id: '/wizard/memberships/$member-number'
      path: '/$member-number'
      fullPath: '/wizard/memberships/$member-number'
      preLoaderRoute: typeof WizardMembershipsMemberNumberRouteRouteImport
      parentRoute: typeof WizardMembershipsRouteRoute
    }
    '/wizard/memberships/$member-number/': {
      id: '/wizard/memberships/$member-number/'
      path: '/'
      fullPath: '/wizard/memberships/$member-number/'
      preLoaderRoute: typeof WizardMembershipsMemberNumberIndexRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/settings/_layout/user-profile/': {
      id: '/settings/_layout/user-profile/'
      path: '/user-profile'
      fullPath: '/settings/user-profile'
      preLoaderRoute: typeof SettingsLayoutUserProfileIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/memberships/': {
      id: '/settings/_layout/memberships/'
      path: '/memberships'
      fullPath: '/settings/memberships'
      preLoaderRoute: typeof SettingsLayoutMembershipsIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/membership-preferences/': {
      id: '/settings/_layout/membership-preferences/'
      path: '/membership-preferences'
      fullPath: '/settings/membership-preferences'
      preLoaderRoute: typeof SettingsLayoutMembershipPreferencesIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/authorized-users/': {
      id: '/settings/_layout/authorized-users/'
      path: '/authorized-users'
      fullPath: '/settings/authorized-users'
      preLoaderRoute: typeof SettingsLayoutAuthorizedUsersIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/accounts/': {
      id: '/settings/_layout/accounts/'
      path: '/accounts'
      fullPath: '/settings/accounts'
      preLoaderRoute: typeof SettingsLayoutAccountsIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/applications/$application-id/service-location/': {
      id: '/applications/$application-id/service-location/'
      path: '/$application-id/service-location'
      fullPath: '/applications/$application-id/service-location'
      preLoaderRoute: typeof ApplicationsApplicationIdServiceLocationIndexRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/identity-check/': {
      id: '/applications/$application-id/identity-check/'
      path: '/$application-id/identity-check'
      fullPath: '/applications/$application-id/identity-check'
      preLoaderRoute: typeof ApplicationsApplicationIdIdentityCheckIndexRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/wizard/memberships/$member-number/tap': {
      id: '/wizard/memberships/$member-number/tap'
      path: '/tap'
      fullPath: '/wizard/memberships/$member-number/tap'
      preLoaderRoute: typeof WizardMembershipsMemberNumberTapRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/wizard/memberships/$member-number/notifications': {
      id: '/wizard/memberships/$member-number/notifications'
      path: '/notifications'
      fullPath: '/wizard/memberships/$member-number/notifications'
      preLoaderRoute: typeof WizardMembershipsMemberNumberNotificationsRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/wizard/memberships/$member-number/newsletter': {
      id: '/wizard/memberships/$member-number/newsletter'
      path: '/newsletter'
      fullPath: '/wizard/memberships/$member-number/newsletter'
      preLoaderRoute: typeof WizardMembershipsMemberNumberNewsletterRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/wizard/memberships/$member-number/go-paperless': {
      id: '/wizard/memberships/$member-number/go-paperless'
      path: '/go-paperless'
      fullPath: '/wizard/memberships/$member-number/go-paperless'
      preLoaderRoute: typeof WizardMembershipsMemberNumberGoPaperlessRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/wizard/memberships/$member-number/complete': {
      id: '/wizard/memberships/$member-number/complete'
      path: '/complete'
      fullPath: '/wizard/memberships/$member-number/complete'
      preLoaderRoute: typeof WizardMembershipsMemberNumberCompleteRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/wizard/memberships/$member-number/aliases': {
      id: '/wizard/memberships/$member-number/aliases'
      path: '/aliases'
      fullPath: '/wizard/memberships/$member-number/aliases'
      preLoaderRoute: typeof WizardMembershipsMemberNumberAliasesRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/settings/_layout/user-profile/update-sms': {
      id: '/settings/_layout/user-profile/update-sms'
      path: '/user-profile/update-sms'
      fullPath: '/settings/user-profile/update-sms'
      preLoaderRoute: typeof SettingsLayoutUserProfileUpdateSmsRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/user-profile/change-password': {
      id: '/settings/_layout/user-profile/change-password'
      path: '/user-profile/change-password'
      fullPath: '/settings/user-profile/change-password'
      preLoaderRoute: typeof SettingsLayoutUserProfileChangePasswordRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/user-profile/change-name': {
      id: '/settings/_layout/user-profile/change-name'
      path: '/user-profile/change-name'
      fullPath: '/settings/user-profile/change-name'
      preLoaderRoute: typeof SettingsLayoutUserProfileChangeNameRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/user-profile/change-email': {
      id: '/settings/_layout/user-profile/change-email'
      path: '/user-profile/change-email'
      fullPath: '/settings/user-profile/change-email'
      preLoaderRoute: typeof SettingsLayoutUserProfileChangeEmailRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/memberships/$memberNumber': {
      id: '/settings/_layout/memberships/$memberNumber'
      path: '/memberships/$memberNumber'
      fullPath: '/settings/memberships/$memberNumber'
      preLoaderRoute: typeof SettingsLayoutMembershipsMemberNumberRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/authorized-users/new': {
      id: '/settings/_layout/authorized-users/new'
      path: '/authorized-users/new'
      fullPath: '/settings/authorized-users/new'
      preLoaderRoute: typeof SettingsLayoutAuthorizedUsersNewRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/accounts/$accountNumber': {
      id: '/settings/_layout/accounts/$accountNumber'
      path: '/accounts/$accountNumber'
      fullPath: '/settings/accounts/$accountNumber'
      preLoaderRoute: typeof SettingsLayoutAccountsAccountNumberRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/applications/$application-id/service-location/new': {
      id: '/applications/$application-id/service-location/new'
      path: '/$application-id/service-location/new'
      fullPath: '/applications/$application-id/service-location/new'
      preLoaderRoute: typeof ApplicationsApplicationIdServiceLocationNewRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/service-location/existing': {
      id: '/applications/$application-id/service-location/existing'
      path: '/$application-id/service-location/existing'
      fullPath: '/applications/$application-id/service-location/existing'
      preLoaderRoute: typeof ApplicationsApplicationIdServiceLocationExistingRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/service-location/confirm': {
      id: '/applications/$application-id/service-location/confirm'
      path: '/$application-id/service-location/confirm'
      fullPath: '/applications/$application-id/service-location/confirm'
      preLoaderRoute: typeof ApplicationsApplicationIdServiceLocationConfirmRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/identity-check/verify-code': {
      id: '/applications/$application-id/identity-check/verify-code'
      path: '/$application-id/identity-check/verify-code'
      fullPath: '/applications/$application-id/identity-check/verify-code'
      preLoaderRoute: typeof ApplicationsApplicationIdIdentityCheckVerifyCodeRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/applications/$application-id/identity-check/security-questions': {
      id: '/applications/$application-id/identity-check/security-questions'
      path: '/$application-id/identity-check/security-questions'
      fullPath: '/applications/$application-id/identity-check/security-questions'
      preLoaderRoute: typeof ApplicationsApplicationIdIdentityCheckSecurityQuestionsRouteImport
      parentRoute: typeof ApplicationsRouteRoute
    }
    '/wizard/memberships/$member-number/automatic-payments/': {
      id: '/wizard/memberships/$member-number/automatic-payments/'
      path: '/automatic-payments'
      fullPath: '/wizard/memberships/$member-number/automatic-payments'
      preLoaderRoute: typeof WizardMembershipsMemberNumberAutomaticPaymentsIndexRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
    '/wizard/memberships/$member-number/automatic-payments/setup': {
      id: '/wizard/memberships/$member-number/automatic-payments/setup'
      path: '/automatic-payments/setup'
      fullPath: '/wizard/memberships/$member-number/automatic-payments/setup'
      preLoaderRoute: typeof WizardMembershipsMemberNumberAutomaticPaymentsSetupRouteImport
      parentRoute: typeof WizardMembershipsMemberNumberRouteRoute
    }
  }
}

interface ApplicationsRouteRouteChildren {
  ApplicationsIndexRoute: typeof ApplicationsIndexRoute
  ApplicationsApplicationIdBillingPreferencesRoute: typeof ApplicationsApplicationIdBillingPreferencesRoute
  ApplicationsApplicationIdConfirmRoute: typeof ApplicationsApplicationIdConfirmRoute
  ApplicationsApplicationIdConsentRoute: typeof ApplicationsApplicationIdConsentRoute
  ApplicationsApplicationIdEndRoute: typeof ApplicationsApplicationIdEndRoute
  ApplicationsApplicationIdSignRoute: typeof ApplicationsApplicationIdSignRoute
  ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute: typeof ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute
  ApplicationsApplicationIdIdentityCheckVerifyCodeRoute: typeof ApplicationsApplicationIdIdentityCheckVerifyCodeRoute
  ApplicationsApplicationIdServiceLocationConfirmRoute: typeof ApplicationsApplicationIdServiceLocationConfirmRoute
  ApplicationsApplicationIdServiceLocationExistingRoute: typeof ApplicationsApplicationIdServiceLocationExistingRoute
  ApplicationsApplicationIdServiceLocationNewRoute: typeof ApplicationsApplicationIdServiceLocationNewRoute
  ApplicationsApplicationIdIdentityCheckIndexRoute: typeof ApplicationsApplicationIdIdentityCheckIndexRoute
  ApplicationsApplicationIdServiceLocationIndexRoute: typeof ApplicationsApplicationIdServiceLocationIndexRoute
}

const ApplicationsRouteRouteChildren: ApplicationsRouteRouteChildren = {
  ApplicationsIndexRoute: ApplicationsIndexRoute,
  ApplicationsApplicationIdBillingPreferencesRoute:
    ApplicationsApplicationIdBillingPreferencesRoute,
  ApplicationsApplicationIdConfirmRoute: ApplicationsApplicationIdConfirmRoute,
  ApplicationsApplicationIdConsentRoute: ApplicationsApplicationIdConsentRoute,
  ApplicationsApplicationIdEndRoute: ApplicationsApplicationIdEndRoute,
  ApplicationsApplicationIdSignRoute: ApplicationsApplicationIdSignRoute,
  ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute:
    ApplicationsApplicationIdIdentityCheckSecurityQuestionsRoute,
  ApplicationsApplicationIdIdentityCheckVerifyCodeRoute:
    ApplicationsApplicationIdIdentityCheckVerifyCodeRoute,
  ApplicationsApplicationIdServiceLocationConfirmRoute:
    ApplicationsApplicationIdServiceLocationConfirmRoute,
  ApplicationsApplicationIdServiceLocationExistingRoute:
    ApplicationsApplicationIdServiceLocationExistingRoute,
  ApplicationsApplicationIdServiceLocationNewRoute:
    ApplicationsApplicationIdServiceLocationNewRoute,
  ApplicationsApplicationIdIdentityCheckIndexRoute:
    ApplicationsApplicationIdIdentityCheckIndexRoute,
  ApplicationsApplicationIdServiceLocationIndexRoute:
    ApplicationsApplicationIdServiceLocationIndexRoute,
}

const ApplicationsRouteRouteWithChildren =
  ApplicationsRouteRoute._addFileChildren(ApplicationsRouteRouteChildren)

interface ApplyRouteRouteChildren {
  ApplyCommercialRoute: typeof ApplyCommercialRoute
  ApplyResidentialRoute: typeof ApplyResidentialRoute
  ApplyVerifyEmailRoute: typeof ApplyVerifyEmailRoute
  ApplyIndexRoute: typeof ApplyIndexRoute
}

const ApplyRouteRouteChildren: ApplyRouteRouteChildren = {
  ApplyCommercialRoute: ApplyCommercialRoute,
  ApplyResidentialRoute: ApplyResidentialRoute,
  ApplyVerifyEmailRoute: ApplyVerifyEmailRoute,
  ApplyIndexRoute: ApplyIndexRoute,
}

const ApplyRouteRouteWithChildren = ApplyRouteRoute._addFileChildren(
  ApplyRouteRouteChildren,
)

interface LoginSignupRouteChildren {
  LoginSignupCreateUserRoute: typeof LoginSignupCreateUserRoute
  LoginSignupLoginRoute: typeof LoginSignupLoginRoute
}

const LoginSignupRouteChildren: LoginSignupRouteChildren = {
  LoginSignupCreateUserRoute: LoginSignupCreateUserRoute,
  LoginSignupLoginRoute: LoginSignupLoginRoute,
}

const LoginSignupRouteWithChildren = LoginSignupRoute._addFileChildren(
  LoginSignupRouteChildren,
)

interface WizardMembershipsMemberNumberRouteRouteChildren {
  WizardMembershipsMemberNumberAliasesRoute: typeof WizardMembershipsMemberNumberAliasesRoute
  WizardMembershipsMemberNumberCompleteRoute: typeof WizardMembershipsMemberNumberCompleteRoute
  WizardMembershipsMemberNumberGoPaperlessRoute: typeof WizardMembershipsMemberNumberGoPaperlessRoute
  WizardMembershipsMemberNumberNewsletterRoute: typeof WizardMembershipsMemberNumberNewsletterRoute
  WizardMembershipsMemberNumberNotificationsRoute: typeof WizardMembershipsMemberNumberNotificationsRoute
  WizardMembershipsMemberNumberTapRoute: typeof WizardMembershipsMemberNumberTapRoute
  WizardMembershipsMemberNumberIndexRoute: typeof WizardMembershipsMemberNumberIndexRoute
  WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute: typeof WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute
  WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute: typeof WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute
}

const WizardMembershipsMemberNumberRouteRouteChildren: WizardMembershipsMemberNumberRouteRouteChildren =
  {
    WizardMembershipsMemberNumberAliasesRoute:
      WizardMembershipsMemberNumberAliasesRoute,
    WizardMembershipsMemberNumberCompleteRoute:
      WizardMembershipsMemberNumberCompleteRoute,
    WizardMembershipsMemberNumberGoPaperlessRoute:
      WizardMembershipsMemberNumberGoPaperlessRoute,
    WizardMembershipsMemberNumberNewsletterRoute:
      WizardMembershipsMemberNumberNewsletterRoute,
    WizardMembershipsMemberNumberNotificationsRoute:
      WizardMembershipsMemberNumberNotificationsRoute,
    WizardMembershipsMemberNumberTapRoute:
      WizardMembershipsMemberNumberTapRoute,
    WizardMembershipsMemberNumberIndexRoute:
      WizardMembershipsMemberNumberIndexRoute,
    WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute:
      WizardMembershipsMemberNumberAutomaticPaymentsSetupRoute,
    WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute:
      WizardMembershipsMemberNumberAutomaticPaymentsIndexRoute,
  }

const WizardMembershipsMemberNumberRouteRouteWithChildren =
  WizardMembershipsMemberNumberRouteRoute._addFileChildren(
    WizardMembershipsMemberNumberRouteRouteChildren,
  )

interface WizardMembershipsRouteRouteChildren {
  WizardMembershipsMemberNumberRouteRoute: typeof WizardMembershipsMemberNumberRouteRouteWithChildren
  WizardMembershipsNewRoute: typeof WizardMembershipsNewRoute
}

const WizardMembershipsRouteRouteChildren: WizardMembershipsRouteRouteChildren =
  {
    WizardMembershipsMemberNumberRouteRoute:
      WizardMembershipsMemberNumberRouteRouteWithChildren,
    WizardMembershipsNewRoute: WizardMembershipsNewRoute,
  }

const WizardMembershipsRouteRouteWithChildren =
  WizardMembershipsRouteRoute._addFileChildren(
    WizardMembershipsRouteRouteChildren,
  )

interface SettingsLayoutRouteChildren {
  SettingsLayoutIndexRoute: typeof SettingsLayoutIndexRoute
  SettingsLayoutAccountsAccountNumberRoute: typeof SettingsLayoutAccountsAccountNumberRoute
  SettingsLayoutAuthorizedUsersNewRoute: typeof SettingsLayoutAuthorizedUsersNewRoute
  SettingsLayoutMembershipsMemberNumberRoute: typeof SettingsLayoutMembershipsMemberNumberRoute
  SettingsLayoutUserProfileChangeEmailRoute: typeof SettingsLayoutUserProfileChangeEmailRoute
  SettingsLayoutUserProfileChangeNameRoute: typeof SettingsLayoutUserProfileChangeNameRoute
  SettingsLayoutUserProfileChangePasswordRoute: typeof SettingsLayoutUserProfileChangePasswordRoute
  SettingsLayoutUserProfileUpdateSmsRoute: typeof SettingsLayoutUserProfileUpdateSmsRoute
  SettingsLayoutAccountsIndexRoute: typeof SettingsLayoutAccountsIndexRoute
  SettingsLayoutAuthorizedUsersIndexRoute: typeof SettingsLayoutAuthorizedUsersIndexRoute
  SettingsLayoutMembershipPreferencesIndexRoute: typeof SettingsLayoutMembershipPreferencesIndexRoute
  SettingsLayoutMembershipsIndexRoute: typeof SettingsLayoutMembershipsIndexRoute
  SettingsLayoutUserProfileIndexRoute: typeof SettingsLayoutUserProfileIndexRoute
}

const SettingsLayoutRouteChildren: SettingsLayoutRouteChildren = {
  SettingsLayoutIndexRoute: SettingsLayoutIndexRoute,
  SettingsLayoutAccountsAccountNumberRoute:
    SettingsLayoutAccountsAccountNumberRoute,
  SettingsLayoutAuthorizedUsersNewRoute: SettingsLayoutAuthorizedUsersNewRoute,
  SettingsLayoutMembershipsMemberNumberRoute:
    SettingsLayoutMembershipsMemberNumberRoute,
  SettingsLayoutUserProfileChangeEmailRoute:
    SettingsLayoutUserProfileChangeEmailRoute,
  SettingsLayoutUserProfileChangeNameRoute:
    SettingsLayoutUserProfileChangeNameRoute,
  SettingsLayoutUserProfileChangePasswordRoute:
    SettingsLayoutUserProfileChangePasswordRoute,
  SettingsLayoutUserProfileUpdateSmsRoute:
    SettingsLayoutUserProfileUpdateSmsRoute,
  SettingsLayoutAccountsIndexRoute: SettingsLayoutAccountsIndexRoute,
  SettingsLayoutAuthorizedUsersIndexRoute:
    SettingsLayoutAuthorizedUsersIndexRoute,
  SettingsLayoutMembershipPreferencesIndexRoute:
    SettingsLayoutMembershipPreferencesIndexRoute,
  SettingsLayoutMembershipsIndexRoute: SettingsLayoutMembershipsIndexRoute,
  SettingsLayoutUserProfileIndexRoute: SettingsLayoutUserProfileIndexRoute,
}

const SettingsLayoutRouteWithChildren = SettingsLayoutRoute._addFileChildren(
  SettingsLayoutRouteChildren,
)

interface SettingsRouteChildren {
  SettingsLayoutRoute: typeof SettingsLayoutRouteWithChildren
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsLayoutRoute: SettingsLayoutRouteWithChildren,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApplicationsRouteRoute: ApplicationsRouteRouteWithChildren,
  ApplyRouteRoute: ApplyRouteRouteWithChildren,
  LoginSignupRoute: LoginSignupRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ExpiredSessionRoute: ExpiredSessionRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ImpersonateRoute: ImpersonateRoute,
  NotificationsRoute: NotificationsRoute,
  WizardMembershipsRouteRoute: WizardMembershipsRouteRouteWithChildren,
  BillingHistoryRoute: BillingHistoryRoute,
  BillingMakePaymentRoute: BillingMakePaymentRoute,
  BillingPaymentSuccessfulRoute: BillingPaymentSuccessfulRoute,
  BillingPaymentsRoute: BillingPaymentsRoute,
  BillingStatementsRoute: BillingStatementsRoute,
  SettingsRoute: SettingsRouteWithChildren,
  UsageElectricRoute: UsageElectricRoute,
  UsageWaterRoute: UsageWaterRoute,
  BillingIndexRoute: BillingIndexRoute,
  UsageIndexRoute: UsageIndexRoute,
  BillingAutomaticPaymentsNewRoute: BillingAutomaticPaymentsNewRoute,
  BillingPaymentMethodsNewCardRoute: BillingPaymentMethodsNewCardRoute,
  BillingPaymentMethodsNewCheckRoute: BillingPaymentMethodsNewCheckRoute,
  UsersResetPasswordTokenRoute: UsersResetPasswordTokenRoute,
  UsersVerifyEmailTokenRoute: UsersVerifyEmailTokenRoute,
  BillingAutomaticPaymentsIndexRoute: BillingAutomaticPaymentsIndexRoute,
  BillingPaymentMethodsIndexRoute: BillingPaymentMethodsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
